export const getAudienceNoDataStyle = (_, { palette = {} }) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,

    '& .no-data-img': {
      height: 279,
    },

    '& .no-data-title': {
      fontSize: 20,
      fontWeight: 600,
      marginBottom: 16,
    },

    '& .no-data-description': {
      color: palette.neutralSecondary,
      fontSize: 16,
    },
  },
});
